import { Component } from '@angular/core';

@Component({
  selector: 'app-hosting-reseller',
  templateUrl: './hosting-reseller.component.html',
  styleUrls: ['./hosting-reseller.component.css']
})
export class HostingResellerComponent {
  navClass = 'nav-light';
    // Set Topbar Option
  Menuoption = 'hosting';
  Settingicon = true
  footerVariant = 'footer-ten';
}
